var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-center border border-danger"},[_c('b',[_vm._v("Draft reports do not show this content.")]),_vm._v(" "),_c('br'),_vm._v(" This content will be available once the product is on the site. ")])}
var staticRenderFns = []

export { render, staticRenderFns }